import { useState, useEffect } from 'react'

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const detectMobile = () => {
            if (typeof window === 'undefined') return false

            // touch + no hover capability
            const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
            const hasHover = window.matchMedia('(hover: hover)').matches

            // mobile: touch device without hover capability
            const isMobileDevice = hasTouch && !hasHover

            setIsMobile(isMobileDevice)
        }

        detectMobile()

        // re-detecting on rotation for tablets
        const handleOrientationChange = () => setTimeout(detectMobile, 100)
        window.addEventListener('orientationchange', handleOrientationChange)

        return () => window.removeEventListener('orientationchange', handleOrientationChange)
    }, [])

    return isMobile
}
